declare global {
  interface Window {
    analytics: any;
    gtag: any;
  }
}

export const trackEvent = (key: string, value: object) => {
  window.analytics.track(key, value);
  window.gtag("event", key, value);
  if (import.meta.env.VITE_APP_ARG === "dev" || import.meta.env.VITE_APP_ARG === "local") {
    console.info("%c[trackEvent] " + key + "\n" + JSON.stringify(value, null, 2), "color: #5c627a");
  }
};
